import { connect } from 'react-redux';
import React from 'react';
import { renderKBMorePhotoUpload, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { KBButton } from
'components';
import config from 'app/config';

const normalizeImages = images => {
  if (Array.isArray(images)) {
    return images.filter(Boolean);
  }

  if (typeof images === 'string') {
    return images
    .split(',')
    .map(image => image.trim())
    .filter(Boolean);
  }

  return [];
};

var LocationImagesUploadForm = class extends React.Component {constructor(props) {super(props);this.submitImages = this.submitImages.bind(this);this.syncImages = this.syncImages.bind(this);}componentDidMount()
  {
    this.syncImages(this.props.defaultImages);
  }componentDidUpdate(

  prevProps) {
    if (prevProps.defaultImages !== this.props.defaultImages) {
      this.syncImages(this.props.defaultImages);
    }
  }syncImages(

  defaultImages) {
    const { fields: { images } } = this.props;
    images.onChange(normalizeImages(defaultImages).join(','));
  }submitImages(

  model) {
    const { imgSubmit } = this.props;
    if (imgSubmit) {
      return imgSubmit(model);
    }
    return null;
  }render()

  {
    const {
      fields: { images },
      handleSubmit,
      submitting,
      defaultImages,
      loc_id } =
    this.props;
    const normalizedDefaultImages = normalizeImages(defaultImages);

    return (
      <form onSubmit={handleSubmit(this.submitImages)}>
        <div className="kb-row">
          <Field name="images" component={renderKBMorePhotoUpload}
          defaultImages={normalizedDefaultImages}
          uploadedText="上传图片"
          photoShow={true}
          sort={true}
          className="kb-form-group kb-form-alone"

          img_width={232}
          img_height={134}
          hint="图片格式为png或jpg,尺寸大小不小于200x150,文件大小不大于10M"
          text="上传图片"
          accept=".png,.jpg"
          imgStyle={{ width: '232px', height: '134px', marginBottom: 10 }}
          prefix={`${config.uploadDir}locations/${loc_id}`}
          isPublic />

        </div>
        <div className="kb-row">
          <KBButton
          className="certain-btn"
          type="submit"
          submitting={submitting}>

            保存图片
          </KBButton>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const { defaultImages } = props;
  return {
    defaultImages };

}

function mapDispatchToProps(dispatch) {
  return {};
}

const LEGACY_FORM_FIELDS = [
  "images"
];

const formConfig = {
  form: 'LocationImagesUploadForm',
  touchOnBlur: false };


LocationImagesUploadForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('LocationImagesUploadForm', LEGACY_FORM_FIELDS)(LocationImagesUploadForm)));

export default LocationImagesUploadForm;
